module.exports = __webpack_public_path__ + "img/research-analyst-4.5d6830e4.svg";